<template>
  <v-container grid-list-md class="pa-5">
    <m-breadcrum :items="bread"></m-breadcrum>
    <v-row v-if="informasi">
      <v-col cols="12" sm="12" md="12" lg="12">
        <m-card title="Pratinjau Informasi">
          <v-row wrap>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
              <v-list>
                <v-row>
                  <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption grey--text">Judul</v-list-item-subtitle>
                        <div class="font-weight-bold body-1">{{ informasi.judul }}</div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption grey--text">Informasi</v-list-item-subtitle>
                        <div class="font-weight-bold body-1" v-html="informasi.informasi"></div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption grey--text">Status</v-list-item-subtitle>
                        <div class="mt-2">
                          <v-chip small :color="$informasi.statusColor(informasi.status)">{{cVal(informasi, 'status')}}</v-chip>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
              </v-list>
            </v-col>
          </v-row>
        </m-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

//@group Jenis Kelas
export default {
  name: "jenis-kelas-detail",
  data() {
    return {
      informasi: {}
    };
  },
  
  activated() {
    this.loadDetail();
  },
  methods: {
   //@vuese
    //tampilkan detail informasi
    loadDetail() {
      return this.$store
        .dispatch("informasi/detail", {
          informasi_id: this.$route.params.informasi_id
        })
        .then(res => {
          this.informasi = res;
        })
        .catch(e => e);
    },
    cVal(obj, a){
      if (obj [a] == 0) {
        return "DRAFT"
      }else if (obj [a] == 1) {
        return "TERBIT"
      }
    }
  },
  computed: {
    bread() {
      return [
        {
          icon: "mdi-library-books",
          title: "Kelola Informasi",
          to: { name: "informasi", params: { instansi_id: this.instansi_id } }
        },
        {
          icon: "mdi-edit",
          title: this.informasi ? this.informasi.judul : "-"
        }
      ];
    },
  }
};
</script>
